<!-- Full page container for the messages list -->
<div fillHeight class="message-container">
  <townip-messages [findRecipientHeight]="430" [containerMatching]="true"></townip-messages>
</div>
